import React from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function CustomTooltip({ active, payload, label, valueLabel }) {
  if (!active || !payload?.length) return null;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm shadow-xl dark:border-white/10 dark:bg-slate-900">
      <p className="font-bold text-slate-950 dark:text-white">{label}</p>
      <p className="text-slate-500 dark:text-white/60">
        {valueLabel} :{" "}
        <span className="font-bold text-slate-950 dark:text-white">
          {payload[0].value}
        </span>
      </p>
    </div>
  );
}

function AdminLineChartCard({
  title,
  subtitle,
  data = [],
  dataKey,
  valueLabel,
  emptyText = "Aucune donnée disponible.",
  gradientId = "lineGradient",
}) {
  const hasData = data.length > 0;

  return (
    <article className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-sky-700 dark:text-sky-200">
          Analyse temporelle
        </p>

        <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
          {title}
        </h2>

        {subtitle && (
          <p className="mt-2 text-sm font-medium text-slate-500 dark:text-white/50">
            {subtitle}
          </p>
        )}
      </div>

      <div className="mt-5 h-[360px]">
        {hasData ? (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 10, right: 20, left: -20, bottom: 0 }}>
              <defs>
                <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#38BDF8" />
                  <stop offset="100%" stopColor="#2563EB" />
                </linearGradient>
              </defs>

              <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.22} />
              <XAxis
                dataKey="date_label"
                tick={{ fontSize: 12, fontWeight: 700 }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                allowDecimals={false}
                tick={{ fontSize: 12, fontWeight: 700 }}
                axisLine={false}
                tickLine={false}
              />
              <Tooltip
                content={<CustomTooltip valueLabel={valueLabel} />}
              />
              <Line
                type="monotone"
                dataKey={dataKey}
                stroke={`url(#${gradientId})`}
                strokeWidth={4}
                dot={{ r: 3, strokeWidth: 2 }}
                activeDot={{ r: 7 }}
              />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div className="flex h-full items-center justify-center rounded-[1.5rem] border border-dashed border-slate-300 bg-slate-50 text-sm font-bold text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
            {emptyText}
          </div>
        )}
      </div>
    </article>
  );
}

export default AdminLineChartCard;